<div class="card">
  <div class="div card-body d-flex justify-content-center">
    <img src="assets/images/development_in_progress.jpg" alt="em construção" />
  </div>
</div>
